var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstaGram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.12329 0C2.74667 0 0 2.74921 0 6.12671V14.8767C0 18.2533 2.74921 21 6.12671 21H14.8767C18.2533 21 21 18.2508 21 14.8733V6.12329C21 2.74667 18.2508 0 14.8733 0H6.12329ZM16.625 3.5C17.108 3.5 17.5 3.892 17.5 4.375C17.5 4.858 17.108 5.25 16.625 5.25C16.142 5.25 15.75 4.858 15.75 4.375C15.75 3.892 16.142 3.5 16.625 3.5ZM10.5 5.25C13.3954 5.25 15.75 7.60462 15.75 10.5C15.75 13.3954 13.3954 15.75 10.5 15.75C7.60462 15.75 5.25 13.3954 5.25 10.5C5.25 7.60462 7.60462 5.25 10.5 5.25ZM10.5 7C9.57174 7 8.6815 7.36875 8.02513 8.02513C7.36875 8.6815 7 9.57174 7 10.5C7 11.4283 7.36875 12.3185 8.02513 12.9749C8.6815 13.6313 9.57174 14 10.5 14C11.4283 14 12.3185 13.6313 12.9749 12.9749C13.6313 12.3185 14 11.4283 14 10.5C14 9.57174 13.6313 8.6815 12.9749 8.02513C12.3185 7.36875 11.4283 7 10.5 7Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstaGram);
export default __webpack_public_path__ + "static/media/InstaGram.2f19e8256d5bade21ed31224b1332b7a.svg";
export { ForwardRef as ReactComponent };